//葡萄牙语
export default {
    今日涨跌:"Variação de hoje",
    商品:"Mercadoria",
    交割:"Entrega",
关于我们:"sobre nós",
账变记录:"Registros de alteração de conta",
股票:"estoque",
加密货币:"criptomoeda",
加载中:"carregando...",
已经全部加载完毕:"Todos foram carregados",
暂无记录:"Não há registros",
高级认证:"Certificação avançada",
姓名:"Nome",
请输入姓名:"Por favor digite seu nome",
护照编号:"Número do Passaporte",
请输入护照编号:"Por favor insira o número do passaporte",
护照照片:"foto do passaporte",
申请认证:"Candidate-se à certificação",
提示:"dica",
确定:"Claro",
提交失败:"Falha no envio",
上传失败:"falha no upload",
身份认证:"Autenticação",
身份证号:"número de identidade",
请输入身份证号:"Por favor insira o número de identificação",
身份证照片:"Foto de identificação",
  全球领先的期货和数字资产平台: "Plataforma líder global de futuros e ativos digitais",
申请认证:"Candidate-se à certificação",
修改资金密码:"Alterar senha do fundo",
旧密码:"Senha Antiga",
请输入旧密码:"Por favor insira a senha antiga",
新密码:"Nova Senha",
请输入6位数字:"Por favor insira 6 dígitos",
确认新密码:"Confirme a nova senha",
请再次输入新密码:"Por favor insira a nova senha novamente",
提交:"enviar",
请输入新密码:"Por favor insira uma nova senha",
请输入6位数新密码:"Por favor insira uma nova senha de 6 dígitos",
请确认两次密码输入一致:"Por favor, confirme se as duas senhas inseridas são consistentes",
修改登录密码:"Alterar senha de login",
密码长度:"Senha (6 a 12 caracteres)",
密码长度提示:"Insira de 6 a 12 caracteres, incluindo números ou letras",
客服:"atendimento ao Cliente",
永续:"Sustentável",
交割:"Entrega",
永续合约:"Contrato perpétuo",
交割合约:"Contrato de entrega",
全仓:"Armazém completo",
开多:"Aberto por muito tempo",
开空:"Abrir curto",
价格:"preço",
开仓金额:"Valor de abertura",
可用金额:"Quantia disponível",
合约金额:"Valor do contrato",
保证金:"margem",
手续费:"taxa de manuseio",
看涨:"otimista",
看跌:"Grosseiro",
交割时间:"prazo de entrega",
数量:"quantidade",
持有仓位:"Mantenha uma posição",
当前委托:"Ordem atual",
历史订单:"Ordens históricas",
暂无数据:"Sem dados",
购买价:"preço de compra",
市价: "preço de mercado",
限价: "limite de preço",
现价:"Preço atual",
金额:"Quantia",
盈亏:"Lucros e perdas",
操作:"operar",
平仓:"Fechar posição",
撤单:"Cancelar pedido",
方向:"direção",
剩余时间:"tempo restante",
交割时间:"prazo de entrega",
详情:"Detalhes",
名称:"nome",
最新价格:"preço mais recente",
h24涨跌:"Altos e baixos 24 horas",
h24涨跌幅:"Aumento e diminuição de 24h",
请输入开仓金额:"Insira o valor de abertura",
请输入开仓价格:"Por favor insira o preço de abertura",
确定执行撤单操作:"Tem certeza de que deseja cancelar o pedido?",
确定执行平仓操作:"Tem certeza de executar a operação de fechamento de posição?",
交割合约历史:"Histórico do contrato de entrega",
历史仓位:"Posições históricas",
到期时间:"Data de validade",
闪兑:"Troca de flash",
从:"de",
最大:"máximo",
可用数量:"Quantidade Disponível",
至:"para",
复制成功:"Copiado com sucesso",
基金理财:"Gestão financeira de fundos",
托管金额:"Valor do depósito",
总收益:"Rendimento total",
当日收益:"Renda do dia",
托管订单:"Ordem de garantia",
规则:"regra",
日收益:"Renda diária",
限额:"limite",
周期:"ciclo",
天:"céu",
立即买入:"Comprar agora",
购买:"Comprar",
购买日:"Data de compra",
起息日:"data de validade",
派息时间:"Prazo de pagamento de dividendos",
每日:"diário",
计息结束日:"Data final do acúmulo de juros",
提前赎回:"resgate antecipado",
预计收益:"Receita estimada",
今日日收益:"Hoje (renda diária)",
最少可投:"Investimento mínimo",
最大可投:"Investimento máximo",
请输入买入金额:"Por favor insira o valor da compra",
可用金额:"Quantia disponível",
请输入买入金额:"Por favor insira o valor da compra",
质押金额:"Valor da promessa",
累计收益:"Renda acumulada",
开始时间:"Hora de início",
结束时间:"Fim do tempo",
理财规则:"regras financeiras",
理财规则1:"A gestão financeira é feita confiando o USD à plataforma, e a equipe profissional da plataforma realiza a arbitragem financeira.Os participantes podem obter uma parte das receitas de gestão financeira da plataforma durante o período de custódia do fundo.",
收益计算:"Cálculo da receita",
理财规则2:"Um membro deposita 10.000U na plataforma e escolhe um produto financeiro com um ciclo de 5 dias e uma renda diária de 0,3%~0,5%.A renda diária é a seguinte:",
最低:"mais baixo",
最高:"Altíssima",
理财规则3:"Ambos: você pode obtê-lo após 5 dias",
理财规则4:"O rendimento é distribuído diariamente. O rendimento distribuído pode ser acessado e sacado a qualquer momento e depositado no principal. Após o vencimento, será automaticamente devolvido à sua conta.",
关于违约金:"Sobre danos liquidados",
理财规则5:"Se você desejar transferir o principal não vencido, serão incorridos danos liquidados.",
理财规则6:"Danos liquidados = índice de liquidação x dias restantes x valor do investimento.",
理财规则7:"Exemplo: O índice de liquidação de danos liquidados deste produto é",
剩余:"Restante",
天到期投资:"Ele expira em dias e o valor do investimento é",
则:"mas",
违约金:"danos liquidados",
实际退还本金为:"O principal real retornado é",
现货账户:"conta à vista",
总资产:"Ativos totais",
充币:"Depositar moedas",
提币:"Retirar moedas",
闪兑:"Troca de flash",
投资组合:"portfólio",
冻结数量:"quantidade congelada",
帮助中心:"Centro de ajuda",
自选:"Opcional",
行情:"Citações",
资金:"fundos",
资讯:"Informação",
我的:"meu",
交易对:"par de negociação",
最新价:"Preço mais recente",
成交量:"Volume",
标记价格:"marcar preço",
h24最高价:"Preço mais alto em 24h",
h24最低价:"24h preço mais baixo",
h24成交量:"Volume de negociação em 24 horas",
h24交易额:"Volume de transações em 24h",
分时:"compartilhamento de tempo",
分1:"1 ponto",
分5:"5 pontos",
分15:"15 marcas",
分30:"30 pontos",
小时1:"1 hora",
天1:"1 dia",
周1:"1 semana",
月1:"Janeiro",
委托订单:"Ordem",
最新交易:"Últimas transações",
买入:"Comprar",
卖出:"vender",
时间:"tempo",
方向:"direção",
取消自选成功:"Cancelar seleção com sucesso",
添加成功:"Adicionado com sucesso",
登录:"Conecte-se",
账户:"Conta",
邮箱:"Correspondência",
手机号:"Número de telefone",
请输入账户:"Por favor insira a conta",
请输入邮箱:"por favor insira seu e-mail",
请输入手机号:"Por favor insira o número de telefone",
密码:"senha",
请输入密码:"Por favor insira a senha",
忘记密码:"esqueceu a senha?",
还没有账号:"Nenhuma conta ainda",
去注册:"Vá para se registrar",
请输入登录账号:"Por favor insira sua conta de login",
请输入登录密码:"Por favor, insira sua senha",
登录失败:"falha no login",
历史记录:"registro histórico",
充值:"completar",
提现:"retirar",
未审核:"Não revisado",
成功:"sucesso",
失败:"falhar",
快捷入口:"Entrada rápida",
资金密码:"Senha do fundo",
登录密码:"senha de login",
账变记录:"Registros de alteração de conta",
邀请推广:"Convidar promoção",
通用:"Universal",
语言:"linguagem",
在线客服:"serviço on-line",
身份认证:"Autenticação",
高级认证:"Certificação avançada",
更多:"Mais",
帮助中心:"Centro de ajuda",
关于我们:"sobre nós",
退出:"desistir",
已提交身份认证:"Você enviou suas informações de identidade e elas estão sob análise",
您已完成身份认证:"Você concluiu a verificação de identidade",
您已完成高级认证:"Você concluiu a Certificação Avançada",
确定退出登录:"Tem certeza que deseja sair?",
资讯:"Informação",
公告:"anúncio",
状态:"estado",
已成交:"Acordo feito",
委托金额:"Valor da comissão",
剩余金额:"equilíbrio",
订单类型:"Tipo de pedido",
市价委托:"ordem de mercado",
限价委托:"ordem limite",
订单号:"número do pedido",
委托时间:"Tempo de comissão",
U本位合约历史:"Histórico de contrato baseado em U",
成交数量:"O número de transações",
实现盈亏:"Realize lucros e perdas",
推广记录:"Registro de promoção",
我的总推广:"Minha promoção geral",
总充值:"Recarga total",
一代人数:"Número de gerações",
二代人数:"Número de segunda geração",
三代人数:"Número de três gerações",
立即推广:"Promova agora",
我的推广:"minha promoção",
用户名:"nome de usuário",
行情:"Citações",
加密货币:"criptomoeda",
外汇:"Forex",
股票:"estoque",
现货交易:"Negociação à vista",
期货:"Negociação de futuros",
热门:"Popular",
涨幅榜:"Lista de ganhadores",
跌幅榜:"Lista de perdedores",
快速充币:"Depósito rápido",
保存二维码:"Salvar código QR",
复制地址:"Copiar endereço",
转出地址:"Endereço de transferência (opcional)",
请输入转出地址:"Por favor insira o endereço de transferência",
粘贴:"Colar",
充币数量:"Valor do depósito",
请输入充币数量:"Por favor insira o valor do depósito",
区块链网络:"Rede Blockchain",
付款凭证:"Comprovante de pagamento (carregar captura de tela dos detalhes do pagamento)",
请输入充值数量:"Insira o valor da recarga",
充值通道:"Canal de recarga",
请选择充值币种:"Selecione a moeda de recarga",
官方充值通道:"Canal oficial de recarga",
设置密码:"configurar senha",
确认密码:"Confirme sua senha",
验证码:"Código de verificação",
请输入验证码:"insira o código de verificação",
获取验证码:"obter código de verificação",
重新发送:"Reenviar",
邀请码:"Código de Convite",
请输入邀请码:"Por favor insira o código do convite",
我已阅读并同意:"eu li e concordo",
服务条款:"Termos de serviço",
注册:"registro",
已有账号:"Já tem uma conta",
去登录:"Ir para login",
请再次输入密码:"Por favor insira a senha novamente",
请同意服务条款:"Por favor, concorde com os termos de serviço",
注册失败:"registração falhou",
欢迎来到:"Bem-vindo ao",
全球最大的区块链资产平台:"A maior plataforma de ativos blockchain do mundo",
分享二维码:"Compartilhar código QR",
链接分享:"Compartilhamento de links",
复制:"cópia de",
您的邀请码:"seu código de convite",
到数字币地址:"Para o endereço da moeda digital",
选择币种:"Escolha a moeda",
区块链网络:"Rede Blockchain",
提币说明:"Instruções de retirada",
提现费用:"Taxas de retirada",
可到账数量:"Quantidade disponível",
可用:"Disponível",
请输入支付密码:"Por favor insira a senha de pagamento",
请输入提币数量:"Por favor insira o valor do saque",
全部:"todos",
支付密码:"Senha de pagamento",
地址:"endereço",
委托价:"Preço do pedido",
成交时间:"Tempo de transação",
成交金额:"Volume de negócios",
委托中:"Em comissão",
持仓中:"Em posição",
平仓中:"Fechamento de posição",
已平仓:"Posição fechada",
开仓倍数:"Abrindo vários",
委托价格:"Preço de comissão",
收盘价:"Preço final",
收益率:"taxa de retorno",
平仓时间:"Horário de encerramento",
请输入转换数量:"Insira a quantidade de conversão",
请上传付款凭证:"Por favor carregue o comprovante de pagamento",
开盘价:"preço de abertura",
开市中:"Abrir",
已休市:"O mercado foi fechado",
美股:"Ações dos EUA",
平仓价:"Preço final",
到期结算完成:"Liquidação de vencimento concluída",
印度股票:"ações indianas",
马来股票:"Ações malaias",
结算中:"Liquidação",
越南股票:"ações do Vietnã",
设置资金密码:"Definir senha do fundo",
请输入资金密码:"Por favor insira a senha do fundo",
取消:"Cancelar",
确定:"Claro",
止损价:"Preço de parada de perda",
请输入止损价格:"Insira o preço do stop loss",
请输入止盈价格:"Insira o preço de lucro",
止盈价:"Preço de lucro",
设置止盈止损:"Definir take-profit e stop loss",
请输入关键词:"Por favor insira uma palavra-chave",
搜索结果:"Procurar Resultados",
添加收款方式:"Adicionar forma de pagamento",
高级认证:"Certificação avançada",
历史委托:"comissão histórica",
选择区域码:"Selecione o código de área",
请上传身份证图片:"Por favor, carregue uma foto do seu cartão de identificação",
请上传护照照片:"Por favor carregue a foto do passaporte",
请输入提币地址:"Por favor, insira o endereço de retirada",
设置语言:"configuração de idioma",
最低金额: "Quantidade mínima",
购买金额: "preço de compra",
请输入要搜索的国家名称: "Por favor insira o nome do país que você deseja pesquisar",
确定执行该操作: "Confirme para fazer isso?",
历史搜索: "Pesquisas históricas",
现货持仓: "Posição pontual",
永续持仓: "Posição perpétua",
到期结算中: "Liquidação na maturidade",
火花图: "diagrama de faísca",
计价单位: "Unidade de vendas",
您拒绝了链接: "Você rejeitou o link",
连接钱包成功: "Conexão da carteira bem-sucedida",
已断开钱包: "Carteira desconectada",
钱包切换成功: "Troca de carteira bem-sucedida",
请先安装钱包插件: "Instale o plug-in da carteira primeiro",
连接钱包: "Conectar carteira",
交易: "troca",
确认报价: "Confirmar cotação",
您将获得: "você vai ter",
兑换自: "Resgatar de",
汇率: "taxa de câmbio",
返回: "retornar",
兑换: "intercâmbio",
消息: "Informação",
身份证反面照片: "Foto do verso da carteira de identidade",
身份证正面照片: "Foto frontal do cartão de identificação",
手持身份证照片: "Foto segurando carteira de identidade",
划转: "transferir",
请输入划转数量: "Por favor insira o valor da transferência(USD)",
邀请链接: "Link de convite",
资料总览: "Visão geral dos dados",
推广规则: "Regras de promoção",
总邀请人数: "Número total de convidados",
总佣金: "comissão total",
安全绑定: "ligação segura",
规则1: "1.Este endereço aceita apenas {type}. Não transfira ativos que não sejam de {type} para este endereço, caso contrário, os ativos não serão recuperados.",
规则2: "2.Depois de recarregar o endereço acima, você precisa aguardar a confirmação do nó da rede. Assim que o nó da rede for confirmado, os ativos chegarão automaticamente à sua conta. Notificaremos você sobre o status de chegada na forma de um anúncio no site.",
规则3: "3.Seu endereço de recarga não mudará com frequência e você poderá recarregar repetidamente; se houver alguma alteração, iremos notificá-lo através de um anúncio no site",

安全中心: "Centro de Segurança",
绑定手机号: "Vincular número de celular",
认证中心: "Centro de Certificação",
身份认证: "Autenticação",
认证要求: "Requisitos de certificação",
政府发行的证件: "Documentos emitidos pelo governo",
功能与限制: "Recursos e limitações",
无限额: "Sem limite",
预计审核时间: "Tempo estimado de revisão: 60 minutos",
开始认证: "Iniciar certificação",
充币规则: "Regras de depósito",
套期保值: "Cobertura, cobertura de risco",
登陆后继续: "Faça login para continuar",
客服充值: "Recarga de atendimento ao cliente",
数字货币: "Moeda digital",
银行取款: "Saque bancário",
请选择充值方式: "Selecione o método de recarga",
请选择取款方式: "Selecione o método de saque",
客服充值: "Recarga de atendimento ao cliente",
数字货币: "Moeda digital",
银行取款: "Saque bancário",
请输入金额: "Por favor insira o valor",
    银行名称: "Nome do banco",
    银行卡号: "Número do cartão bancário",
    请输入: "Por favor insira",
    请选择: "Por favor selecione",
    类型: "Tipo",
    可用金额: "Valor disponível",
    提款: "Retirada"
}


// WEBPACK FOOTER //
// ./src/lang/pt.js